import { Box, Grid, Link, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { HelpIcon } from "../svgIcon/HelpIcon";

const FormWrapperLogin = ({ children }) => {
  const enviroment = process.env.REACT_APP_ENVIROMENT_DEPLOYMENT;
  const educationLink = process.env.REACT_APP_EDUCATION_PAGE;
  const applicationVersion = process.env.REACT_APP_APPLICATION_VERSION;
  const educationValueChain = process.env.REACT_APP_Introduction_aquaculture_value_chain;
  const lunchGoalUrl = process.env.REACT_APP_LUNCH_GOAL;
  const mainPageUrl = process.env.REACT_APP_MAIN_PAGE;
  const loginUrl = process.env.REACT_APP_LOGIN;
  const legalRegistrationUrl = process.env.REACT_APP_LEGAL_REGISTRATION;
  const realRegistrationUrl = process.env.REACT_APP_REAL_REGISTRATION;
  const farahushcomUrl = process.env.REACT_APP_FARAHUSHCOM_LINK;
  const theme = useTheme();

  function slugify(title) {
    return title.trim().replace(/\s+/g, "-");
  }
  const handleOpenPopup = (url, title) => {
    if (!url || typeof url !== "string") return;
    const parts = url.split("/");
    const videoHash = parts.pop() || null;
    const slug = slugify(title);
    const FinalUrl = `${educationLink}/${videoHash}-${slug}`;
    window.open(FinalUrl, "_blank", "width=800,height=800,left=100,top=100,resizable=yes,scrollbars=yes");
  };

  const goToTracking = () => {
    window.location.href = "https://avc724.ir/";
  };

  const handleFarahoshcom = () => {
    window.open(farahushcomUrl, "_blank");
  };

  return (
    <>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item xs={6} position="fixed" left="0" top="0" width="100%" height="100%">
          <img
            src="/static/images/AVC_Welcome.jpg"
            alt="login"
            height="100%"
            width="100%"
            style={{ objectFit: "cover" }}
          />
        </Grid>
        <Grid item xs={6} right="0" top="0" position="absolute" width="100%">
          <Stack width="100%" sx={{ height: "100vh" }} p={1} justifyContent="center" alignItems="center">
            <Box p={2} onClick={goToTracking}>
              <Typography variant="h6" mt={2} color="primary" textAlign={"center"}>
                زیست بوم دیجیتالی محصولات کشاورزی
              </Typography>
              <Typography variant="h6" mt={2} color="primary" textAlign={"center"}>
                زنجیره ارزش آبزیان
              </Typography>
              {enviroment === "DEV" || enviroment === "TEST" ? (
                <Typography variant="h6" mt={2} color="primary" textAlign={"center"}>
                  نسخه آزمایشی
                </Typography>
              ) : null}
            </Box>
            <Stack spacing={4} px={12} width="100%" justifyContent="center" alignItems="center">
              {children}
            </Stack>
          </Stack>
        </Grid>
      </Grid>
      <Stack
        position="fixed"
        sx={{
          width: {
            xs: 400,
            md: 400,
            lg: 500,
          },
        }}
        height={150}
        bottom={80}
        left={20}
        flexDirection={"column"}
        justifyContent={"start"}
      >
        <Stack flexDirection={"row"} gap={1}>
          <Stack>
            <Stack mt={3}>
              <HelpIcon color={theme.palette.primary.main} sx={{ fontSize: 70 }} />
            </Stack>
          </Stack>
          <Stack gap={0.5} flexDirection={"column"}>
            <Link
              onClick={() => handleOpenPopup(educationValueChain, " آشنایی با زنجیره ارزش آبزیان")}
              rel="noopener noreferrer"
              underline="hover"
              sx={{ color: theme.palette.info.main, cursor: "pointer" }}
            >
              آشنایی با زنجیره ارزش آبزیان
            </Link>
            <Link
              onClick={() => handleOpenPopup(lunchGoalUrl, "اهداف راه‌اندازی سامانه")}
              rel="noopener noreferrer"
              underline="hover"
              sx={{ color: theme.palette.info.main, cursor: "pointer" }}
            >
              اهداف راه‌اندازی سامانه
            </Link>
            <Link
              onClick={() => handleOpenPopup(loginUrl, "نحوه ورود به سامانه")}
              rel="noopener noreferrer"
              underline="hover"
              sx={{ color: theme.palette.info.main, cursor: "pointer" }}
            >
              نحوه ورود به سامانه
            </Link>
            <Stack flexDirection={"row"} gap={1}>
              <Typography color={"grey.gm"} variant="body1">
                نحوه ثبت‌نام در سامانه:
              </Typography>
              <Link
                onClick={() => handleOpenPopup(realRegistrationUrl, "کاربر حقیقی")}
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: theme.palette.info.main, cursor: "pointer" }}
              >
                کاربر حقیقی
              </Link>
              <Typography
                sx={{ textDecoration: "underline", color: theme.palette.info.main, cursor: "pointer" }}
                variant="body1"
              >
                ,
              </Typography>
              <Link
                onClick={() => handleOpenPopup(legalRegistrationUrl, "کاربر حقوقی")}
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: theme.palette.info.main, cursor: "pointer" }}
              >
                کاربر حقوقی
              </Link>
            </Stack>
             <Stack flexDirection={"row"} gap={1}>
              <Typography   sx={{color: theme.palette.info.main, cursor: "pointer" }}
                variant="body1">
                شماره مرکز تماس و پشتیبانی: 09990312338 - 09990312336 
              </Typography>
            </Stack>
            <Link
              onClick={() => handleOpenPopup(mainPageUrl, "اهداف راه‌اندازی سامانه")}
              rel="noopener noreferrer"
              underline="hover"
              sx={{ color: theme.palette.info.main, cursor: "pointer" }}
            >
              محیط اصلی سامانه دلفین
            </Link>
          </Stack>
        </Stack>
        <Stack onClick={handleFarahoshcom} flexDirection={"row"} sx={{ cursor: "pointer" }} mt={2} ml={2}>
          <Link rel="noopener noreferrer" underline="hover" sx={{ color: theme.palette.info.main, cursor: "pointer" }}>
            ایجادشده توسط شرکت فناوری اطلاعات فراهوش کام (نسخه {applicationVersion})
          </Link>
        </Stack>
      </Stack>
    </>
  );
};

export default FormWrapperLogin;
